module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("‘Everyone here in this room is living on borrowed time. By rights, we should all be …dead!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only reason that God allowed us this extra ration of life is so we can make life hell for the enemy! Three bloody deep, bloody long tunnels will be dug: Tom, Dick and Harry. One will succeed!’")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("Quote of Mastermind of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Great Escape")]), _vm._v(", Squadron Leader Roger Bushell"), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d597cf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Dedication.vue
// module id = 69
// module chunks = 0